var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview"},[(_vm.label)?_c('div',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"preview__container"},[(_vm.deliveryModeIcon)?_c(_vm.deliveryModeIcon.component,{tag:"component",attrs:{"kind":_vm.deliveryModeIcon.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.deliveryModeLabel))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }